import { ExportApi } from "@/api";
import { downloadFile } from "@/support/file";

export async function exportLessons() {
  const { data } = await ExportApi.exportLessons();
  downloadFile(data, "Lessons report has been correctly generated");
}

export async function exportStudentsReport(year, onlyActive, userActiveRole) {
  const { data } = await ExportApi.exportStudentsReport(
    year,
    onlyActive,
    userActiveRole
  );
  downloadFile(data, "Students report has been correctly generated");
}

export async function getSemesterInfo(
  selectedSemester,
  onlyActive,
  userActiveRole
) {
  const { data } = await ExportApi.getSemesterInfo(
    selectedSemester,
    onlyActive,
    userActiveRole
  );
  downloadFile(data, "Semester report has been correctly generated");
}

export async function exportStudyPlan(userActiveRole) {
  const { data } = await ExportApi.exportStudyPlan(userActiveRole);
  downloadFile(data, "Study plan report has been correctly generated");
}
